/* Progressive gallery enhancement; no checkout or subscriber writes. */
(() => {
  if (window.ukuProductStories) return;
  window.ukuProductStories = true;
  const initialise = (scope = document) => {
    scope.querySelectorAll('.uku-pdp:not([data-pdp-ready])').forEach((root) => {
      root.dataset.pdpReady = 'true';
      const image = root.querySelector('[data-pdp-main]');
      const opener = root.querySelector('[data-pdp-open]');
      const thumbs = [...root.querySelectorAll('[data-pdp-thumb]')];
      const modal = root.querySelector('[data-pdp-modal]');
      const modalImage = root.querySelector('[data-pdp-modal-image]');
      if (!image || !opener || !modal || !modalImage) return;
      const choose = (thumb) => {
        image.src = thumb.dataset.src;
        image.alt = thumb.dataset.alt;
        opener.href = thumb.dataset.src;
        thumbs.forEach((item) => item.setAttribute('aria-current', String(item === thumb)));
        root.querySelector('[data-pdp-caption]').textContent = thumb.dataset.caption;
        root.querySelector('[data-pdp-counter]').textContent = `${String(thumb.dataset.index).padStart(2, '0')} / ${String(thumbs.length).padStart(2, '0')}`;
      };
      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', (event) => { event.preventDefault(); choose(thumb); });
        thumb.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % thumbs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + thumbs.length) % thumbs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = thumbs.length - 1;
          if (next !== undefined) { event.preventDefault(); choose(thumbs[next]); thumbs[next].focus(); }
        });
      });
      opener.addEventListener('click', (event) => {
        if (typeof modal.showModal !== 'function') return;
        event.preventDefault(); modalImage.src = image.src; modalImage.alt = image.alt;
        root.querySelector('[data-pdp-modal-caption]').textContent = root.querySelector('[data-pdp-caption]').textContent + ' - Concept render';
        modal.showModal();
      });
      root.querySelector('[data-pdp-close]').addEventListener('click', () => modal.close());
      modal.addEventListener('click', (event) => { if (event.target === modal) { const b=modal.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)modal.close(); } });
      modal.addEventListener('close', () => opener.focus({preventScroll:true}));
      const sync = () => document.querySelectorAll('[data-product-interest], [data-uku-wa-product]').forEach((select) => {
        if ([...select.options].some((o) => o.value === root.dataset.productTitle)) {select.value = root.dataset.productTitle;select.dispatchEvent(new Event('change',{bubbles:true}));}
      });
      sync();
      const sticky = root.querySelector('[data-pdp-sticky]');
      const primary = root.querySelector('[data-pdp-primary]');
      if (sticky && primary && 'IntersectionObserver' in window) {
        let primaryInView=true; const formsInView=new Set();
        const refresh=()=>{sticky.hidden=primaryInView||formsInView.size>0||primary.getBoundingClientRect().bottom>0;};
        const observer=new IntersectionObserver((entries)=>{entries.forEach((entry)=>{if(entry.target===primary)primaryInView=entry.isIntersecting;else if(entry.isIntersecting)formsInView.add(entry.target);else formsInView.delete(entry.target);});refresh();},{threshold:0});
        observer.observe(primary);document.querySelectorAll('#uku-waitlist,#uku-whatsapp').forEach((el)=>observer.observe(el));
        document.addEventListener('shopify:section:unload',(event)=>{if(event.target.contains(root))observer.disconnect();},{once:true});
      }
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialise());else initialise();
  document.addEventListener('shopify:section:load',(event)=>initialise(event.target));
})();
